"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DEFAULT_LANGUAGE = void 0;
exports.DEFAULT_LANGUAGE = 'en-US';
//# sourceMappingURL=defaultLanguage.js.map